export const paymentSetupRouteNames = {
    default: 'payment_setup',
  }
  